import { restRequest } from "vrcore-dashboard/dist/utilities";
export const GET_REGISTERED_USERS = restRequest(
    "VRCORE_DASHBOARD_V2.ACTIVITYFEED_WIDGET.GET_REGISTERED_USERS"
);
export const GET_FEED = restRequest(
    "VRCORE_DASHBOARD_V2.ACTIVITYFEED_WIDGET.GET_FEED"
);
export const GET_REPORT_TITLES = restRequest(
    "VRCORE_DASHBOARD_V2.ACTIVITYFEED_WIDGET.GET_REPORT_TITLES"
);
export const DELETE_ACTIVITY = restRequest(
    "VRCORE_DASHBOARD_V2.ACTIVITYFEED_WIDGET.DELETE_ACTIVITY"
);